import Vuex from 'vuex'
var timeoutSelectFieldSearch = null;
export const selectorMixin = {
    props:{
        required: {
            type: Boolean,
            default: false
        }, 
        validation: {
            type: Function,
            default: null
        },
        validationOnChange: {
            type: Boolean,
            default: false
        },
        helpText: {
            type: String,
            default: null
        }
    },
    computed: {
        ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
        computedValidationStatus() {
            return this.isValid === null ? "" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
        },
        dataProvidersRef(){
            return app.dataproviders;
        },
        containerClasses() {
            return `${this.inLine ? 'row' : ''} ${this.classes ? this.classes : ''}`;
        },
        labelClasses() {
            let sizeClass = this.size ? `col-form-label-${this.size}` : '';
            let inlineClass = this.inLine ? `${this.inlineLabelColClass} col-form-label` : '';
            return `${sizeClass} ${inlineClass}`;
        },
        selectClasses() {
            let sizeClass = this.size ? `form-control-${this.size}` : '';
            return sizeClass;
        },
        optionListDataProvider() {
            if (typeof this.options === 'string') {
                let strArr = this.options.split(".");
                if (strArr.length === 3) {
                    if (this.dataProvidersRef) {
                        return this.dataProvidersRef[strArr[0]];
                    }
                } else if (strArr.length === 2) {
                    return this.$parent.data_provider_ref;
                }
            }
            return null;
        },
        providerOptions() {
            try {
                let options = this.loadedOptions;
                if (Array.isArray(this.options)) {
                    options = JSON.parse(JSON.stringify(this.options));
                } else if (typeof this.options === 'string') {
                    let strArr = this.options.split(".");
                    if (strArr.length === 3) {
                        if (this.dataProvidersRef) {
                            options = this.dataProvidersRef[strArr[0]].result[strArr[1]][strArr[2]];
                        }
                    } else if (strArr.length === 2) {
                        options = this.$parent.data_provider_ref.result[strArr[0]][strArr[1]];
                    } else {
                        throw "Invalid Provider or property Name"
                    }
                }
                if (this.optionFilter != null && typeof this.optionFilter === "function") {
                    options = options.filter(this.optionFilter);
                }
                return options;
            } catch (err) {
                console.log(this.options);
                console.log('KS-APP: ',err);
                return [];
            }
        }
    },
    watch:{
        filterOptionsSearch: function (newVal, oldVal) {
            try {
                if (timeoutSelectFieldSearch) {
                    clearTimeout(timeoutSelectFieldSearch);
                }
                if (this.optionListDataProvider != null && this.enableDBSearch) {
                    timeoutSelectFieldSearch = setTimeout(() => {
                        this.optionListDataProvider.updateFilters({'search_string': newVal && newVal.length > 0 ? newVal : null});
                        if (this.consoleLogs) console.log("filterOptionsSearch loadList");
                        this.optionListDataProvider.loadList();
                        /*this.optionListDataProvider.listRecords({
                            campaign_id: this.optionListDataProvider && this.optionListDataProvider.campaignId ? this.optionListDataProvider.campaignId : app.activePage.multiCampaign ? this.optionListDataProvider.selected_campaigns.map(cp => cp.id).join() : (this.optionListDataProvider.selected_campaign ? `${this.optionListDataProvider.selected_campaign}` : null),
                            search_string: newVal && newVal.length > 0 ? newVal : null,
                            row_count_skip: 0,
                            row_count_take: this.optionListDataProvider.pageSize,
                            ...this.optionListDataProvider.filter_options,
                        }, null, false);*/
                    }, 800);
              } else if( this.enableSearch ) {
                if (newVal.length > 0) {
                    timeoutSelectFieldSearch = setTimeout(() => {
                        this.filteredOptions = this.input_options.filter((o) => {
                            if(this.isCustom){
                              if(typeof o[this.optionLabel] !== 'undefined') {
                                return o[this.optionLabel].toLowerCase().includes(newVal.toLowerCase())
                              }
                            }else{
                              return o.label.toLowerCase().includes(newVal.toLowerCase())
                            }
                         });
                    }, 800);
                } else {
                  this.filteredOptions = JSON.parse(JSON.stringify(this.input_options));
                }
              }
            } catch (err) {
              console.log('KS-APP: ',err);
            }
        },
        cValue: function(newVal, oldVal){
            if(typeof newVal !== 'undefined' && this.validationOnChange) this.validate_input();
        }
    },
    methods: {
        newOptionClicked() {
            this.$emit('onNewClick', this);
        },
        allOptionClicked() {
            this.$emit('onAllClick', this);
        },
        validate_input() {
            //run required default validation
            if(this.required){
                if (!this.cValue || `${this.cValue}`.length == 0 || this.cValue.length == 0) {
                    this.isValid = false;
                    this.validText =  null;
                    this.invalidText = ['This Field is Required'];
                    return false //{isValid: false, errors: ['This Field is Required']}
                }else{
                    this.isValid = true;
                    this.validText =  null;
                    this.invalidText = null;
                    return true;
                }
            }
            //run custom validation function
            if (this.validation !== null && typeof this.validation === 'function' ) {
                let source = this.$parent && typeof this.$parent.dataSource !== 'undefined'?this.$parent.dataSource:null;
                let res = this.validation(this.cValue,source);
                this.isValid = res.isValid;
                this.validText = res.correct ? res.correct : null;
                this.invalidText = res.errors ? res.errors : null;
                return res.isValid;
            } else {
                return true;
            }
        }
    },
    async created(){
        try{
            if(typeof this.options === 'function'){
                this.loadedOptions = await this.options();
            }
        }catch(err){
            console.log(err);
        }
    },
    data(){
        return {
            isValid: null,
            validText: null,
            invalidText: null,
            loadedOptions : []
        }
    }

}